import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFirestore, collection, query, where, getDocs, increment, getDoc, doc, updateDoc, setDoc} from 'firebase/firestore';
import GeneralNavbar from './GeneralNavbar';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './OfferNotificationManager.css';
import { getStorage, ref, uploadString, getDownloadURL } from "firebase/storage";


const OfferNotificationManager = () => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [offerMessage, setOfferMessage] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const db = getFirestore();
        const usersRef = collection(db, 'users');
        const q = query(usersRef, where('role', '==', 'cliente'), where('recibirNotificaciones', '==', true));
        const querySnapshot = await getDocs(q);

        const clients = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

        setUsers(clients);
      } catch (error) {
        console.error('Error al obtener los usuarios:', error);
        alert('Ocurrió un error al cargar los usuarios. Por favor, intenta nuevamente.');
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result); // Convertimos la imagen a base64
      };
      reader.readAsDataURL(file);
    } else {
      setSelectedImage(null);
    }
  };

  const handleSendNotifications = async () => {
    if (!offerMessage.trim() && !selectedImage) {
      alert("Por favor, escribe un mensaje de oferta o selecciona una imagen.");
      return;
    }
  
    let imageUrl = null;
  
    if (selectedImage) {
      try {
        const storage = getStorage();
        const storageRef = ref(storage, `offers/${Date.now()}.jpg`);
        const uploadResult = await uploadString(storageRef, selectedImage, "data_url");
        imageUrl = await getDownloadURL(uploadResult.ref);
      } catch (error) {
        console.error("Error al subir la imagen:", error);
        alert("No se pudo subir la imagen. Intenta nuevamente.");
        return;
      }
    }
  
    const db = getFirestore();
    const today = new Date().toISOString().split("T")[0]; // Fecha actual en formato yyyy-mm-dd
    const limitRef = doc(db, "emailLimits", today);
  
    try {
      const limitSnapshot = await getDoc(limitRef);
      let emailsSent = 0;
  
      if (limitSnapshot.exists()) {
        emailsSent = limitSnapshot.data().emailsSent || 0;
      }
  
      if (emailsSent + users.length > 500) {
        alert("No puedes enviar más de 500 correos por día.");
        return;
      }
  
      const payload = {
        emails: users
          .map((user) => user.email?.trim())
          .filter((email) => email && /\S+@\S+\.\S+/.test(email)),
        message: offerMessage.trim(),
        image: imageUrl,
      };
  
      if (payload.emails.length === 0) {
        alert("No hay usuarios con correos válidos para enviar notificaciones.");
        return;
      }
  
      const response = await fetch(
        "https://sendofferemails-gimkn5c4xa-uc.a.run.app", // URL de tu función
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
  
      const data = await response.json();
  
      if (response.ok && data.success) {
        alert("Correos enviados exitosamente");
  
        // Actualizar el contador de correos enviados
        if (limitSnapshot.exists()) {
          await updateDoc(limitRef, {
            emailsSent: increment(users.length),
          });
        } else {
          await setDoc(limitRef, {
            emailsSent: users.length,
          });
        }
  
        setOfferMessage("");
        setSelectedImage(null);
      } else {
        alert("Error al enviar correos");
        console.error("Error del backend:", data);
      }
    } catch (error) {
      console.error("Error al enviar notificaciones:", error);
      alert("Error al enviar notificaciones. Revisa la consola para más detalles.");
    }
  };

  const handleBackClick = () => {
    navigate('/admin');
  };

  return (
    <div>
      <GeneralNavbar title="Notificaciones Por Email" onBackClick={handleBackClick} />

      <div className="offer-notification-manager-container">
        {loading ? (
          <p className="loading-message">Cargando usuarios...</p>
        ) : (
          <>
            <ReactQuill
              value={offerMessage}
              onChange={setOfferMessage}
              className="offer-message-editor"
              placeholder="Escribe el mensaje de la oferta aquí..."
            />

            <div className="image-upload-container">
              <label htmlFor="image-upload" className="image-upload-label">
                Subir Imagen (opcional):
              </label>
              <input
                type="file"
                id="image-upload"
                accept="image/*"
                onChange={handleImageChange}
                className="image-upload-input"
              />
              {selectedImage && (
                <img
                  src={selectedImage}
                  alt="Vista previa"
                  className="image-preview"
                />
              )}
            </div>

            <button
              onClick={handleSendNotifications}
              className="offer-send-button"
              disabled={loading || users.length === 0}
            >
              Enviar Notificaciones
            </button>

            <p className="user-count-message">
              {users.length > 0
                ? `${users.length} usuarios recibirán la notificación.`
                : "No hay usuarios disponibles para recibir la notificación."}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default OfferNotificationManager;




